var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9297 15.8984C18.1406 15.6875 18.1406 15.3359 17.9297 15.125L13.3828 10.5547C13.1484 10.3438 12.7969 10.3438 12.5859 10.5547L12.0469 11.0938C11.8359 11.3047 11.8359 11.6562 12.0469 11.8906L15.6562 15.5L12.0469 19.1328C11.8359 19.3672 11.8359 19.7188 12.0469 19.9297L12.5859 20.4688C12.7969 20.6797 13.1484 20.6797 13.3828 20.4688L17.9297 15.8984Z",
    fill: "#363ED3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRightArrow);
export default __webpack_public_path__ + "static/media/icon-right-arrow.99a458457a4eb66269ba02c5a2aea92e.svg";
export { ForwardRef as ReactComponent };